import React from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import integrationStyles from "../integrationStyles";
import AppTheme from "../../../AppTheme";
import Header from "../Header";
import IntegrationIcons from "../../../common/icons/integrations/index";
import appStyles from "../../../../appStyles";
import { navigate } from "../../../../../helpers/utils";
import appPages from "../../../../../appPages";
import steps from "../steps";
import ManaButton from "../../../common/ManaButton";

export default function HealthIntegrationDone({
  controller,
  goToStep = () => {},
  isFromCard = false,
}) {
  const buttonText = isFromCard ? "Finish" : "Continue";

  const onButtonPress = () => {
    if (isFromCard) {
      navigate(controller, appPages.integrationsV2);
    } else {
      goToStep(steps.checklist);
    }
  };
  return (
    <>
      <Header
        title="You’re all set!"
        controller={controller}
        goBack={() => goToStep(steps.health)}
      />

      <KeyboardAvoidingView behavior="position">
        <ScrollView style={(appStyles.scrollView, { paddingHorizontal: 16 })}>
          <View
            style={{
              alignItems: "center",
              marginTop: 99,
              marginBottom: 55,
            }}
          >
            <IntegrationIcons.HealthBigIcon />
          </View>

          <Text style={styles.sectionText}>Thanks for connecting.</Text>
          <Text style={styles.sectionText}>
            We’re looking forward to sharing insights with you!
          </Text>
        </ScrollView>
      </KeyboardAvoidingView>

      <View style={[appStyles.footerButtons]}>
        <ManaButton
          isMainButton
          onPress={onButtonPress}
          style={appStyles.bottomButton}
          textStyle={appStyles.bottomButtonText}
          text={buttonText}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  desktopIcon: {
    width: 279,
    height: 266,
  },
});
